let _baseHostUrl: string = "";

export const BaseHostUrlService = {
  get(): string {
    return _baseHostUrl;
  },
  set(value: string): void {
    _baseHostUrl = value;
  },
};
